import {createVIPProgramResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const VIPProgramSchema = z.object({
  id: z.string().nullable(),
  storeID: z.string().nullable(),
  startDate: z.string().nullable(),
  expirationType: z.number().nullable(),
  entryMethodType: z.number().nullable(),
  status: z.number().nullable(),
  plannedProcessDateTime: z.string().nullable(),
  processing: z.boolean().nullable(),
})

export const VIPProgramSchemaResponse = createVIPProgramResponseSchema(VIPProgramSchema)

export type VIPProgram = z.infer<typeof VIPProgramSchema>
export type VIPProgramResponse = z.infer<typeof VIPProgramSchemaResponse>
